import { useState } from "react";
import Button from "@components/forms/Button/Button";
import TextField from "@components/forms/TextField/TextField";
import FlashProps from "@ltypes/flashProps";
import Select from "@components/forms/Select/Select";
import './PomodoroFlash.scss';

type PomodoroFlashProps = {
} & FlashProps;

function PomodoroFlash(props: PomodoroFlashProps) {
    const [workTime, setWorkTime] = useState<string>('25:00');
    const [breakTime, setBreakTime] = useState<string>('5:00');

    const handleStart = () => {
        props.onStart({
            work_time: workTime,
            break_time: breakTime,
        })
    };

    return (
        <>
            <div className="d-flex justify-content-center gap-3">
                <Select label="Work time" items={new Array(60).fill(0).map((_, index: number) => ({
                    label: `${index+1}:00`,
                    value: `${index+1}:00`,
                }))} onChange={(value: string) => setWorkTime(value)} value={workTime}/>
                <Select label="Break time" items={new Array(60).fill(0).map((_, index: number) => ({
                    label: `${index+1}:00`,
                    value: `${index+1}:00`,
                }))} onChange={(value: string) => setBreakTime(value)} value={breakTime}/>
            </div>
            <div className="mt-2 d-flex justify-content-center gap-3">
                <Button onClick={handleStart}>Start</Button>
            </div>
        </>
    );
}

export default PomodoroFlash;
